<svelte:head>
	<script src='https://cdnjs.cloudflare.com/ajax/libs/tabletop.js/1.5.1/tabletop.min.js' on:load={loadActivities}></script>

	<!-- Mailchimp -->
	<script type="text/javascript" src="//downloads.mailchimp.com/js/signup-forms/popup/unique-methods/embed.js" data-dojo-config="usePlainJson: true, isDebug: false" onload="mailchimp();"></script>
	<script type="text/javascript">function mailchimp() { setTimeout(function() { window.dojoRequire(["mojo/signup-forms/Loader"], function(L) { L.start({"baseUrl":"mc.us8.list-manage.com","uuid":"69c13c0876ca43a972e10b3cf","lid":"2f47306ab8","uniqueMethods":true}) })}, 15000)}</script>
</svelte:head>

<script>
	import Newsletter from './Newsletter.svelte'
	import Title from './Title.svelte'
	import Activity from './Activity.svelte'
	import Loader from './Loader.svelte'
	import SubmitActivityBox from './SubmitActivityBox.svelte'
	import SubmitAnotherBox from './SubmitAnotherBox.svelte'
	import Modal from './Modal.svelte'
	import './Style.svelte'
	import { flip } from 'svelte/animate';
	import Icon from 'fa-svelte'
	import { faHeart as heart } from '@fortawesome/free-solid-svg-icons/faHeart'
	import { faCheck as check } from '@fortawesome/free-solid-svg-icons/faCheck'
    import { faPaperPlane as paperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane'
	import PullToRefresh from 'pulltorefreshjs';
	import { quintOut, elasticOut } from 'svelte/easing';
	import { blur, scale, draw, fly, slide, fade, crossfade } from 'svelte/transition';

	let loading = false
	let selectedTab = 'trending'
	let submitState = 'default'
	$: showingNewsletter = false

	$: activities = []
	$: orderedActivities = orderByTab(activities, selectedTab)

	const ptr = PullToRefresh.init({
		mainElement: 'body',
		onRefresh() {
			loadActivities()
		}
	});

	function toggleTabs(newTab) {
		selectedTab = newTab
		// orderActivities();
	}
	
	var publicSpreadsheetUrl = 'https://docs.google.com/spreadsheets/d/1N6ezQreACoX_jujzcST_jIFAVdy8kWCMELeDNnM540g/edit?usp=sharing';
	
	function loadActivities() {
		localStorage['needsRefresh'] = JSON.stringify(true)
		loading = true
		Tabletop.init( { 
			key: publicSpreadsheetUrl,
			callback: setupActivities,
			simpleSheet: true,
			parseNumbers: true,
			postProcess: function(element) {
				element["show"] = (element["show"] == "TRUE" ? true : false)
			} 
		} )
	}

	function setupActivities(data, tabletop) {
		activities = data
		setUpLocalStorage(activities);
		loading = false
		localStorage['needsRefresh'] = JSON.stringify(false)
	}

	function setUpUniqueID() {
		let stored = localStorage['userID'];
		if (!stored) localStorage['userID'] = 'user_' + Math.random().toString(36).substr(2, 9)
	}

	function setUpLocalStorage(activities) {
		let stored = localStorage['activities'];
		if (!stored) localStorage['activities'] = JSON.stringify({});
		
		let localActivities = JSON.parse(localStorage['activities'])	
		
		activities.forEach(e => {
			if (!(e.activityId in localActivities)) {
				localActivities[e.activityId] = {userLiked: false, userDone: false}
			}
		});
		localStorage['activities'] = JSON.stringify(localActivities)
	}
	
	function isLiked(activity) {
		return JSON.parse(localStorage['activities'])[activity['activityId']]['userLiked']
	}

	function isDone(activity) {
		return JSON.parse(localStorage['activities'])[activity['activityId']]['userDone']
	}

	function orderByTab(orderActivities, selectedTab) {		
		switch(selectedTab) {
			case 'recent':
				orderedActivities = activities.sort(function(a,b) {return b.timestamp - a.timestamp})
				break;
			case 'trending':
				orderedActivities = activities.sort(function(a,b) {return b.likes + b.done - a.likes - a.done})
				break;
			case 'liked':
				orderedActivities = activities.filter(activity => isLiked(activity))
				break;
			case 'done':
				orderedActivities = activities.filter(activity => isDone(activity))
				break;
			default:
				orderedActivities = activities.sort(function(a,b) {return b.likes - a.likes})
				break;
		}
		return orderedActivities.filter(activity => activity['show'])
	}
	setUpUniqueID()

	function clickSubmitIdea() {
		submitState = 'showForm'
	}

	function submitting(event) {
		loading = true
		toggleTabs("recent")
	}

	function submitSuccessful(event) {
		loading = false
		loadActivities()
		submitState = 'submittedForm'
	}

	function submitAnother(event) {
		submitState = 'showForm'
	}

	function resetSubmitState(event) {
		submitState = 'default'
	}

	function updateActivities(interaction) {
		activities.forEach( e => {
			if (e.activityId == interaction.detail.activityId) {
				e[interaction.detail.toggled] += interaction.detail.toggleAmount
			}
		})
	}

	// Animations

	const [send, receive] = crossfade({
		duration: d => Math.sqrt(d * 200),

		fallback(node, params) {
			const style = getComputedStyle(node);
			const transform = style.transform === 'none' ? '' : style.transform;

			return {
				duration: 600,
				easing: quintOut,
				css: t => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`
			};
		}
	});

	// setTimeout(function() {
	// 	showingNewsletter = true
	// 	// 	setTimeout(function() {
	// 	// 	showingNewsletter = false
	// 	// }, 6000);
	// }, 2000);
</script>

<style>

	main {
		display: grid;
		align-content: center;
		row-gap: 1rem;
		max-width: 60rem;
		padding: 2rem 1rem;
		box-sizing: border-box;
		margin: auto;
		width: 100%;
	}
	
	main > * {
		transition: 1s ease all;
	}

	ul {
		list-style-type: none;
		padding: 0;
		display: grid;
		align-items: center;
		grid-template-columns: repeat(auto-fill, minmax(min(100%, 25rem), 1fr));
		grid-gap: 1rem;
		margin: 0;
	}

	li {
		box-sizing: border-box;
		height: 100%;
	}

	.wide {
		grid-column: 1 / span 2;
	}

	refresh-top {
		float: right;
		overflow: auto;
	}

	tabs {
		/* height: 2rem; */
		width: auto;
		overflow-x: scroll;
		overflow-y: hidden;
		transition: 400ms;
	}

	tabs > button {
		margin-right: 0rem;
	}

	icon {
		vertical-align: middle;
		margin-left: 0.5rem;
		margin-right: 0.5rem;
	}

	.loaderContainer {
		width: 100%;
		height: 8rem;
		margin: auto;
		display: grid;
		align-content: center;
	}

	animated {
		width: 100%;
	}

</style>

<Modal>
	{#if showingNewsletter}
		<!-- <Newsletter bind:visible={showingNewsletter}/> -->
	{/if}
<main>
	
	<Title/>

	{#if (submitState == 'default')}
	<button in:scale='{{delay:400, start: 0.8, duration:400}}' out:fade='{{duration:400}}' on:click={clickSubmitIdea} class='primary'>
		<icon><Icon icon={paperPlane}></Icon></icon>Submit an activity
	</button>
	{:else if (submitState == 'showForm')}
	<animated in:slide='{{delay: 400, x:500, duration:400}}' out:slide='{{duration:400}}'>
		<SubmitActivityBox on:cancel={resetSubmitState} on:submitting={submitting} on:submitSuccessful={submitSuccessful}/>
	</animated>
	{:else if (loading == true)}
	<div in:fade='{{duration: 400}}' out:fade='{{duration:400}}' class='loaderContainer'>
		<Loader/>
	</div>
	{:else if (submitState == 'submittedForm')}
	<animated in:scale='{{delay: 400, duration:800, easing: elasticOut, start: 0.8}}' out:fly='{{x:-200, duration:400}}'>
		<SubmitAnotherBox on:yes={submitAnother} on:no={resetSubmitState} />
	</animated>
	{/if}

	<tabs>
		<button class:gray='{selectedTab != 'trending'}' on:click='{toggleTabs.bind(this, "trending")}'>Popular</button>
		<button class:gray='{selectedTab != 'recent'}' on:click='{toggleTabs.bind(this, "recent")}'>Newest</button>
		<refresh-top>
		<button class='{selectedTab == 'liked' ? 'red' : 'gray'}' on:click='{toggleTabs.bind(this, "liked")}'><icon><Icon icon={heart}></Icon></icon></button>
		<button class:gray='{selectedTab != 'done'}' on:click='{toggleTabs.bind(this, "done")}'><icon><Icon icon={check}></Icon></icon></button>
			<!-- {#if loading}
			<Loader/>
			{:else}
			<button class='gray' on:click={loadActivities}>Refresh</button>
			{/if} -->
		</refresh-top>
	</tabs>

	<ul>
		<!-- {#if loading && activities.length > 4}
		<li in:fly='{{delay: 400, x:-200, duration:400}}'>
			<div class='loaderContainer'>
				<Loader/>
			</div>
		</li>
		{/if} -->
		{#each orderedActivities as activity, index (activity)}
			<li 
			in:receive="{{key: activity.activityId }}"
			out:send="{{key: activity.activityId}}"
			animate:flip="{{duration: 800}}">
				<Activity on:interaction={updateActivities} {...activity}/>
			</li>
		{/each}
	</ul>
	{#if loading}
	<Loader/>
	{:else}
	<button class='tertiary' on:click={loadActivities}>Refresh</button>
	{/if}
</main>
</Modal>